module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_engl_primaerlogo_pos.80119d4c.pdf";